<!-- Main Error Wrapper Start -->
<div class="error-main-wrapper">
    <div class="error-inner-content vh-100">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-8">
                    <h1 class="font-weight-bold">Service Unavailable!</h1>
                    <p class="fs-22">
                        We’re currently performing maintenance or experiencing a temporary system issue.
                        Please try again later.
                    </p>
                </div>
                <div class="col-lg-4 py-5">
                    <span class="material-symbols-outlined fs-220">
                        cloud_off
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>